module.exports = __webpack_public_path__ + "static/LucilleSitting-9d73242346b1b97a7cad578c47c64091.jpg";